import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const fetchRole = async (roleId: string): Promise<RoleResponse> => {
	const response = await cmsClient.get<RoleResponse>(`/roles/${roleId}/`);
	return response.data;
};

const useRole = (roleId: string) => {
	return useQuery(["roles", roleId], () => fetchRole(roleId), {
		enabled: !!roleId
	});
};

export default useRole;
